const base_url = "https://www.flapone.com/flapone-api/flapone-api-3.0";
//const base_url = "http://local.flapone.noida/flapone-api";
const domainurl  = "https://www.flapone.com/";
const weburl  = "https://www.flapone.com/";

const invoicepdfurl = "https://media.flapone.com/images/flapone-crm/assets/flaponeinvoicepdf/";

export default {base_url,domainurl,weburl,invoicepdfurl}
